module.exports = __webpack_public_path__ + "assets/9f655d2a34765c5e6d63c2a56b8e18b7.png";